var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRaster3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 17.57L10.19 12.18L13.75 15.23L15.54 14.08L21.45 19.08L24.94 16.18L27.62 18.09",
    stroke: "#DDD7D7",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.42999 9.21001H10.48",
    stroke: "#DDD7D7",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3 13.16H27.62",
    stroke: "#DDD7D7",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.43 12.28C21.5511 12.28 22.46 11.3711 22.46 10.25C22.46 9.12886 21.5511 8.22 20.43 8.22C19.3089 8.22 18.4 9.12886 18.4 10.25C18.4 11.3711 19.3089 12.28 20.43 12.28Z",
    fill: "#DDD7D7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.03 26H4.67C3.79 26 3.09 25.29 3.09 24.42V6.59C3.09 5.71 3.8 5 4.67 5H26.03C26.91 5 27.61 5.71 27.61 6.58V24.41C27.62 25.29 26.91 26 26.03 26Z",
    stroke: "#DDD7D7",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaster3);
export default __webpack_public_path__ + "static/media/raster3.84d2744546a8490a08fdf2c809c11ae6.svg";
export { ForwardRef as ReactComponent };